import { EventBus } from "../eventBus/nav-bar-event";
import globals from '../globals'
// Notification Mixin
export default {
    data() {
      return {
        notificationsList: [],
        notificationsCount: 0,
        count: 0,
      };
    },
    methods: {
      // Getting All Notification
      getNotificationRequests(request_type) {
        this.notificationsList = []
        this.ajaxCallinprogress = true;
        var request_type = 'personal'
        if(this.account)
        request_type = 'employee';
        this.$http
          .post("/notifications/accepted_notifications", {
            skip: this.skip,
            limit: 5,
            // only_crm: true,
            // product_id: "",
            search_key: "",
          })
          .then(res => {
            if (res.data.status_id == 1) {
              this.notificationsList = res.data.response;
              this.count = this.notificationsList.length
              this.notificationsCount = res.data.count
              this.ajaxCallinprogress = false;
            }
          });
      },
      // Delete Notification API
      deleteNotificationRequests(id) {
        this.$http
          .post("/notifications/delete_notifications", {
            notifications : [id]
          })
          .then(res => {
            if (res.data.status_id == 1) {
              EventBus.$emit("updateNotification")
              this.$awn.success("Notification Deleted Successfully")
            }
            else {
              this.$awn.alert("Something Went Wrong! Please try again")
            }
            this.getNotificationRequests()
          });
      },
      // Mark as Read Notification
      notificationRead(id) {
        this.$http
          .post("/notifications/mark_notifications_as_read", {
            notifications : [id]
          })
          this.getNotificationRequests()
      },

      /**
       * Notifications List View
       */

      async NotificationsList(params){
        return new Promise(async(resolve, reject) => {
          try{
            let response = await this.$http.post(globals.CRM_API + '/notifications/list', params)
            if(response.data.status_id){
              resolve(response.data)
            } else {
              reject(response.data.reason)
            }
          }
          catch(error){
            this.warning_msg = error.response.data.reason
            this.$refs.warning_modal.open();
            setTimeout(() => {
                this.$refs.warning_modal.close();
            }, 3000);
          }
        })
      },
      async MarkAsRead(id){
        return new Promise(async(resolve, reject) => {
          try{
            let response = await this.$http.post(globals.CRM_API + '/notifications/mark/read', id)
            if(response.data.status_id){
              resolve(response.data)
            } else {
              reject(response.data.reason)
            }
          }
          catch(error){
            this.warning_msg = error.response.data.reason
            this.$refs.warning_modal.open();
            setTimeout(() => {
                this.$refs.warning_modal.close();
            }, 3000);
          }
        })
      }
    },
  };
  


// WEBPACK FOOTER //
// ./src/components/mixins/notification.js